<template>
  <div
    class="information-owner-table-toolbar d-flex align-center justify-space-between flex-wrap"
    data-testid="information-owner-table-toolbar"
  >
    <SearchBar
      :value="searchQuery"
      placeholder="Search"
      width="275px"
      data-testid-prefix="information-owner-table-toolbar"
      :disabled="loading"
      @input="$emit('update:searchQuery', $event)"
    />

    <div class="information-owner-table-toolbar__actions d-flex align-center">
      <v-btn
        v-if="hasActiveTableFilter"
        text
        class="data-table-action__clear-filter-btn"
        data-testid="information-owner-table-toolbar__clear-filter-btn"
        @click="$emit('clear-filter')"
      >
        <span>Clear Filter</span>
      </v-btn>

      <v-btn
        v-if="canEdit"
        color="primary"
        class="white--text"
        data-testid="information-owner-table-toolbar__add-owner-btn"
        @click="$emit('add-owner')"
      >
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>Add Owner</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import './InformationOwnerTableToolbar.scss';
import { SearchBar } from '../../../../../components';

export default {
  name: 'InformationOwnerTableToolbar',
  components: {
    SearchBar,
  },
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    hasActiveTableFilter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
